export default __webpack_public_path__ + "static/media/about-top-image-large.9d4bd612.JPEG";